import React from 'react'

import { isUsBilling } from 'libs/billing/stripe-account'
import { Loader } from 'shared/components/Loader'
import useAxios from 'hooks/useAxios'
import useFeatureToggle from 'hooks/useFeatureToggle'
import { useTaxPreview } from 'hooks/useTaxPreview'
import AccountPlanAndUsage from '.'

/**
 *
 * @param {object} props
 * @param {object} props.accountUsageData
 * @param {import('.').Plan} props.plan
 * @param {import('.').Subscription} props.subscription
 * @param {import('.').Coupon} props.coupon
 * @param {React.ReactNode} props.failedPaymentMessageElement
 * @param {function} props.onModalOpened
 * @param {string} props.cancellationLink
 */
export default function AccountPlanAndUsageContainer({
  accountUsageData,
  plan,
  subscription,
  coupon,
  failedPaymentMessageElement,
  onModalOpened,
  cancellationLink,
  billing,
}) {
  const { enableBillingUsTax } = useFeatureToggle()
  const hasInvoice = ['active', 'past_due'].includes(subscription?.status)
  const hasTaxPreview = hasInvoice && isUsBilling(billing) && !!enableBillingUsTax
  const { data: savedBillingAddress } = useAxios({
    url: 'billing/customers/billing-address/',
    skip: !hasTaxPreview,
  })
  const { preview, isLoading: isNextInvoiceAmountLoading } = useTaxPreview({
    enabled: hasTaxPreview,
    refreshKey: JSON.stringify([plan?.id ?? null, savedBillingAddress?.address ?? null]),
  })
  const nextInvoiceAmount = preview?.status === 'complete' ? preview.total / 100 : null

  if (!accountUsageData) {
    return <Loader withContainer />
  }

  return (
    <div>
      <AccountPlanAndUsage
        plan={plan}
        dueDate={accountUsageData.billing_period.end || null}
        subscription={subscription}
        coupon={coupon}
        onModalOpened={onModalOpened}
        cancellationLink={cancellationLink}
        nextInvoiceAmount={nextInvoiceAmount}
        isNextInvoiceAmountLoading={isNextInvoiceAmountLoading}
        failedPaymentMessageElement={failedPaymentMessageElement}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/AccountPlanAndUsage/container.js